import { MatDialogRef } from '@angular/material';
import { Component } from '@angular/core';

@Component({
    selector: 'app-modal-message-dialog',
    styleUrls: ['./modal-message-dialog.component.scss'],
    templateUrl: './modal-message-dialog.component.html',
})
export class ModalMessageDialogComponent {
  public title: string;
  public firstMessage: string;
  public msgList: string[];
  constructor(public dialogRef: MatDialogRef<ModalMessageDialogComponent>) {}
}



// WEBPACK FOOTER //
// ./src/app/shared-components/modals/modal-message-dialog.component.ts